import { EnumService } from '../../../services/enum.service';
import { SalaryScaleGroupService, ISalaryScaleGroup } from '../../../services/salaryScaleGroup.service';

class AccountBasicInfoController {
    private onUpdate: any;
    private account: any;
    private type: any;
    private salaryScaleGroups: ISalaryScaleGroup[];

    constructor(
        private $state: ng.ui.IStateService, 
        private EnumService: EnumService,
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private $timeout: ng.ITimeoutService
    ) {
        'ngInject';       
       // console.log('AccountBasicInfoController');
    }

    $onInit = () => {
        this.salaryScaleGroups = [];
        
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            this.salaryScaleGroups = result || [];
            
            // Als account een salaryScaleGroup object heeft, maar het is niet hetzelfde referentie object
            // Zoek het juiste object op basis van ID en gebruik die referentie (belangrijk voor ng-options)
            if (this.account && this.account.salaryScaleGroup && this.account.salaryScaleGroup.id) {
                const foundGroup = this.salaryScaleGroups.find(g => g.id === this.account.salaryScaleGroup.id);
                if (foundGroup) {
                    // Gebruik het object uit de array zodat de referentie overeenkomt met ng-options
                    this.account.salaryScaleGroup = foundGroup;
                }
            } else if (this.account && this.account.salaryScaleGroupId && !this.account.salaryScaleGroup) {
                // Als account alleen een salaryScaleGroupId heeft maar geen object, zoek het object op
                const foundGroup = this.salaryScaleGroups.find(g => g.id === this.account.salaryScaleGroupId);
                if (foundGroup) {
                    this.account.salaryScaleGroup = foundGroup;
                }
            }
            
            // Trigger chosen update after data is loaded
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('.chosen').trigger('chosen:updated');
                }
            }, 200);
        }).catch((error) => {
            console.error('Error loading salary scale groups:', error);
            this.salaryScaleGroups = [];
        });
    }

    submitAccountBasicInfo() {
       // console.log('update AccountBasicInfo');

        // Zorg dat salaryScaleGroupId wordt gezet op basis van het geselecteerde object
        if (this.account.salaryScaleGroup && this.account.salaryScaleGroup.id) {
            this.account.salaryScaleGroupId = this.account.salaryScaleGroup.id;
        } else {
            this.account.salaryScaleGroupId = null;
            this.account.salaryScaleGroup = null;
        }

        this.onUpdate({account: this.account});

        (<any>$('#accountBasicInfoModal')).modal('hide');
    }
}

export const accountBasicInfoComponent = {
    bindings: {
        type: '<',
        account: '<',
        onUpdate: "&"
    },
    controller: AccountBasicInfoController,
    template: require('./accountBasicInfoModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/accountBasicInfoModal.component.ts